<template>
    <div>
        <template v-for="cart, index in carts">
            <cart-list-item v-model="carts[index]" :key="index" @remove="carts.splice(index, 1)" />
        </template>
    </div>
</template>
<script>
import CartListItem from "@/components/client/shop/product/cart-list-item.vue";
export default {
    components: {
        CartListItem
    },
    props: ["value"],
    data(){
        return {
            carts: this.$props.value
        }
    },
    watch: {
        carts: {
            deep: true,
            handler(){
                this.$emit("input", this.carts);
            }
        }
    }
}
</script>